<template>
    <div class="container pt-2">
        <PageTitle main="Relatório de Cadastro de Funcionários" sub="" />
        <div class="row justify-content-md-center" v-if="isLoading">
            <b-spinner variant="success" label="Spinning"></b-spinner>
        </div>
        <b-button variant="success" block class="mt-2 mb-2 botaoInput" @click="callReport" v-if="!visualizaReport && !isLoading">Gerar Relatório</b-button>
        <hr v-if="!visualizaReport">
        <b-button variant="warning" block class="mt-2 mb-2 botaoInput" :href="link" v-if="visualizaReport">Salvar</b-button>
        <hr v-if="visualizaReport">
        <div :style="{ overflow: overflowValue, width: larguraTela + 'px' }" v-if="larguraTela<721">
            <b-table 
                hover 
                striped 
                id="table-funcionarios" 
                class="text-center table table-sm" 
                :items="funcionarios.length>0?funcionarios:[]" 
                :fields="fields">
            </b-table>
            <div class="row" v-if="exibeRodape">
                <div class="col-md-12 text-center mb-3">
                    <span class="text-custom"><i>Não há nenhum dado disponível!</i></span>
                </div>
            </div>
        </div>
        <div v-else>
            <b-table 
                hover 
                striped 
                id="table-funcionarios" 
                class="text-center table table-sm" 
                :items="funcionarios.length>0?funcionarios:[]" 
                :fields="fields" >
            </b-table>
            <div class="row" v-if="exibeRodape">
                <div class="col-md-12 text-center mb-3">
                    <span class="text-custom"><i>Não há nenhum dado disponível!</i></span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { baseApiUrl } from '@/global'
import axios from 'axios'
import PageTitle from '@/components/template/PageTitle'

export default {
    name: 'funcionarios',
    components: { PageTitle },
    data: function() {
        return {
            larguraTela: 0,
            overflowValue: 'auto',
            visualizaReport: false,
            isLoading: false,
            link: '',
            exibeRodape: true,
            funcionarios: [],
            fields: [
                { key: 'nome', label: 'Nome', sortable: true, thClass: 'tituloTabela', tdClass: 'fieldsTabela' },
                { key: 'telefone', label: 'Telefone', sortable: true, thClass: 'tituloTabela', tdClass: 'fieldsTabela' },
                { key: 'email', label: 'E-mail', sortable: true, thClass: 'tituloTabela', tdClass: 'fieldsTabela' }
            ]
        }
    },
    methods: {
        loadFuncionarios() {
            const url = `${baseApiUrl}/backend/funcionarios.php`
            axios.get(url).then(res => {
                this.funcionarios = res.data
                if(this.funcionarios.length > 0) {
                    this.exibeRodape = false
                }else{
                    this.exibeRodape = true
                }
            })
        },
        callReport() {
            this.isLoading = true
            const url = `${baseApiUrl}/backend/repFuncionarios.php`
            axios.get(url).then((res) => {
                this.isLoading = false
                this.visualizaReport = true
                this.link = res.data['result']
            })
        }
    },
    mounted() {
        this.visualizaReport = false
        this.loadFuncionarios()
        this.larguraTela = screen.width - (screen.width * 0.08)
    }
}
</script>

<style>
</style>